import { useCallback } from 'react';
import { useRouter } from 'next/router';
import { parseQueryParamValue } from '@/creditflowresearch/ui/common/utils/query/parseQueryParams';

interface IUseFilterQueryParserResult {
  getCurrentAbbreviations: (filterKey: string) => string[],
  parseQueryValue: (value: string | string[] | undefined) => string[],
}

export const useFilterQueryParser = (): IUseFilterQueryParserResult => {
  const { query } = useRouter();

  const getCurrentAbbreviations = useCallback((filterKey: string): string[] => {
    return parseQueryParamValue(query[filterKey]);
  }, [query]);

  const parseQueryValue = useCallback((value: string | string[] | undefined): string[] => {
    return parseQueryParamValue(value);
  }, []);

  return {
    getCurrentAbbreviations,
    parseQueryValue,
  };
};
